/*
* @Author: Gang Jiang
* @Date: 2024-12-09 14:00:26
* @Last Modified by: Gang Jiang
* @Last Modified time: 2025-01-07 09:43:55
*/

<template>
  <div class="filters" ref="filtersWrapper">
    <a-popover trigger="click" placement="bottom" v-model:open="visible" overlayClassName="filters-popover"
      :getPopupContainer="() => $refs.filtersWrapper">
      <artmisads-select-button showFilterIcon="true" :filterNum="filtersNum" showDownIcon="true">Filters
      </artmisads-select-button>
      <template #content>
        <div class="filters-down" ref="filtersDown">
          <div class="filters-name">Marketplace</div>
          <artmisads-select :width="200" class="country" :dropdownMatchSelectWidth="false"
            v-model:value="filters.countryCode" @change="setCountry($event)"
            :getPopupContainer="() => $refs.filtersDown">
            <a-select-option class="country-select-item" key="all" value="All" />
            <a-select-option class="country-select-item" v-for="item in Object.keys(CURRENCY_MAPPER)"
              :key="item.toLowerCase()" :value="item">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="'#icon-guoqi-' + item.toLowerCase()"></use>
              </svg>{{ CURRENCY_MAPPER[item].host }}
            </a-select-option>
          </artmisads-select>
          <template v-if="activeTab == '0'">
          <div class="filters-name" >Primary ID</div>
          <artmisads-select :width="200" class="country" :dropdownMatchSelectWidth="false"
            v-model:value="filters.primaryTrackingId" @change="setPrimaryTrackingId($event)"
            :getPopupContainer="() => $refs.filtersWrapper">
            <a-select-option class="source-select-item" v-for="item in primaryTrackingIdOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </artmisads-select>
        </template>
        <template v-if="activeTab == '0'">
          <div class="filters-name">Sub ID</div>
          <artmisads-select :width="200" class="country" :dropdownMatchSelectWidth="false"
            v-model:value="filters.subTrackingId"  @select="(value, option) => onChangePrimaryTrackingId(value, option)"
            :getPopupContainer="() => $refs.filtersWrapper">
            <a-select-option class="source-select-item" v-for="item in subTrackingIdOptions" :key="item.id" :value="item.id" :dataItem="item">
              {{ item.name }}
            </a-select-option>
          </artmisads-select>
        </template>
        <template v-if="activeTab == '0'">
          <div class="filters-name">Source</div>
          <artmisads-select :width="200" class="country" :dropdownMatchSelectWidth="false"
            v-model:value="filters.sourceId" @change="setSource($event)"
            :getPopupContainer="() => $refs.filtersWrapper">
            <a-select-option class="source-select-item" v-for="item in sourceOptions" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </artmisads-select>
        </template>
          <div class="filters-name" v-if="filters.pageType === 'Product'">Brands</div>
          <a-auto-complete v-if="filters.pageType === 'Product'" class="brand-autocomplete" :allowClear="true"
            @clear="clearBrands" @keyup="searchBrands" @select="selectbrand" @blur="brandBlur"
            :options="brandSuggestions" placeholder="Please enter..." v-model:value="filters.brandKeywords" />
          <div v-if="filters.pageType === 'Product'" class="filters-name">Commission Min</div>
          <div v-if="filters.pageType === 'Product'" class="commission-input">
            <artmisads-input-number min="0" max="100" suffix="%" :step="0.1" class="width100"
              v-model:value="filters.commission" placeholder="Please enter..." />
          </div>
        </div>
        <div class="btns">
          <a @click="reset(false, true,filters.pageType,activeTab)" :class="'reset' + (filtersNum ? '' : ' disabled')" href="javascript:;">
            <span style="margin-right: 3px">Reset</span><span class="filter-num" v-show="filtersNum">{{ filtersNum
              }}</span><span style="margin-left: 3px">Filters</span>
          </a>
          <artmisads-button class="save" type="primary" @click="updateFilters">Confirm</artmisads-button>
        </div>
      </template>
    </a-popover>
  </div>
</template>

<script setup>
import { publisherApi } from '~/server'
import { CURRENCY_MAPPER } from '~/contants/common'
import { publisherProductApi } from '../../../server'
import { ref, defineEmits, defineProps, defineExpose, watch } from 'vue'
import { trackingIdsApi } from "~/server/publisher/trackingIds"
import { message } from 'ant-design-vue'
const { init } = defineProps(['init'])
const emit = defineEmits(['updateFilters'])
const filters = ref({ ...init, brandKeywords: '', commission: null })
const filtersWrapper = ref(null)

let options = []
let filtersNum = ref(0)
let filtersDown = ref()
let visible = ref(false)
const sourceOptions = ref([])
const brandSelected = ref(false)
const brandSuggestions = ref([])
const primaryTrackingIdOptions = ref([])
const subTrackingIdOptions = ref([])
const allSubTrackingIdOptions=ref([])
let filtersOrigi = {
  sourceId: 1,
  brandName: '',
  countryCode: 'All',
  commission: null,
}
const activeTab = ref('0')

// 监听 commission 变化来更新过滤器状态
watch(() => filters.value.commission, (newValue, oldValue) => {
  setCommission(newValue)
})

function updateFilters() {

  visible.value = false
  const primaryTrackingId=primaryTrackingIdOptions.value.find(item=>{
    return item.id==filters.value.primaryTrackingId
  })?.name
  const subTrackingId=allSubTrackingIdOptions.value.find(item=>{
    return item.id==filters.value.subTrackingId
  })?.name
  const callbackObj={
    ...filters.value,
    primaryTrackingId,
    subTrackingId
  }
  emit('updateFilters', callbackObj)
}

function setCountry(country) {
  let isMark = options.includes('countryCode')

  if (!isMark && country != filtersOrigi['countryCode']) {
    options.push('countryCode')
    filtersNum.value++
  } else {
    if (isMark && country == filtersOrigi['countryCode']) {
      options = options.filter((i) => i != 'countryCode')

      if (filtersNum) {
        filtersNum.value--
      }
    }
  }

  filters.value.countryCode = country
}
function setSource(sourceId) {
  if (filtersOrigi.sourceId != sourceId && sourceId) {
    if (!options.includes('sourceId')) {
      filtersNum.value += 1
      options.push('sourceId')
    }
  } else {
    if (options.includes('sourceId')) {
      filtersNum.value -= 1
      options = options.filter((i) => i != 'sourceId')
    }
  }
}
function setPrimaryTrackingId(primaryTrackingId) {
  if (filtersOrigi.primaryTrackingId != primaryTrackingId && primaryTrackingId) {
    if (!options.includes('primaryTrackingId')) {
      filtersNum.value += 1
      options.push('primaryTrackingId')
    }
  } else {
    if (options.includes('primaryTrackingId')) {
      filtersNum.value -= 1
      options = options.filter((i) => i != 'primaryTrackingId')
    }
  }
  subTrackingIdOptions.value=[]
  filters.value.subTrackingId=''
  if (options.includes('subTrackingId')) {
      filtersNum.value -= 1
      options = options.filter((i) => i != 'subTrackingId')
    }
  getSubTrackingId(primaryTrackingId)

}
const getSubTrackingId=async(id)=>{
    let {success,data,error}=await trackingIdsApi.getSubTrackingIds(id).catch(e=>({success:false,error:e.message}))
    if(success){
      subTrackingIdOptions.value=data.map(item=>{
            return {
              name:item.trackingId,
                id:String(item.id) 
            }
        })
    }else{
        message.error(error)
    }
}

const onChangePrimaryTrackingId=async(value,option)=>{
  if (filtersOrigi.subTrackingId != value && value) {
    if (!options.includes('subTrackingId')) {
      filtersNum.value += 1
      options.push('subTrackingId')
    }
  } else {
    if (options.includes('subTrackingId')) {
      filtersNum.value -= 1
      options = options.filter((i) => i != 'subTrackingId')
    }
  }
  if(filters.value.primaryTrackingId===''){
    filters.value.primaryTrackingId=option.dataItem.parentId
    getSubTrackingId(filters.value.primaryTrackingId)
    if (filtersOrigi.primaryTrackingId != option.dataItem.parentId && option.dataItem.parentId) {
    if (!options.includes('primaryTrackingId')) {
      filtersNum.value += 1
      options.push('primaryTrackingId')
    }
  } else {
    if (options.includes('primaryTrackingId')) {
      filtersNum.value -= 1
      options = options.filter((i) => i != 'primaryTrackingId')
    }
  }
    // setPrimaryTrackingId(filters.value.primaryTrackingId)
  }
}
function setCommission(v) {
  // 确保 filters.commission 被正确更新
  // filters.value.commission = v
  
  // 检查是否有有效的佣金值（包括0）
  const hasValidValue = v !== null && v !== undefined && v !== ''
  const isChanged = filtersOrigi.commission !== v
  
  if (hasValidValue && isChanged) {
    if (!options.includes('commission')) {
      filtersNum.value += 1
      options.push('commission')
    }
  } else {
    if (options.includes('commission')) {
      filtersNum.value -= 1
      options = options.filter((i) => i != 'commission')
    }
  }
}

function brandBlur() {
  if (!brandSelected.value) {
    reset(false, true,filters.value.pageType,activeTab.value)
  }
}

function reset(updateList = true, visibility = false, pageType = null,restActiveTab) {
  visible.value = visibility
  filters.value.pageType = pageType || filters.value.pageType
  activeTab.value = restActiveTab || '0'
  if (filtersNum.value) {
    options = []
    filtersNum.value = 0
    filters.value.sourceId = 1
    brandSelected.value = false
    filters.value.brandName = ''
    filters.value.commission = null
    filters.value.countryCode = 'All'
    filters.value.brandKeywords = ''
    filters.value.primaryTrackingId = ''
    filters.value.subTrackingId = ''
    // console.log(filters.value,'filters.value')
    subTrackingIdOptions.value=JSON.parse(JSON.stringify(allSubTrackingIdOptions.value))
    if (updateList) {
      emit('updateFilters', filters.value)
    }
  }
}

function clearBrands() {
  filtersNum.value -= 1
  brandSelected.value = false
  brandSuggestions.value = ''
  filters.value.brandName = ''
  filters.value.brandKeywords = ''
  options = options.filter((i) => i != 'brandName')
  getBrandsList('')
}

function searchBrands(e) {
  const v = e.target.value.trim()

  brandSelected.value = false

  getBrandsList(v)
}

function getBrandsList(keywords) {
  publisherApi.getBrandsSuggestion(keywords).then((res) => {
    if (res.success) {
      brandSuggestions.value = res.data.map((item) => {
        return { label: item.brandName, value: item.brandName }
      })
    }
  })
}
const getTrackingId=async()=>{
    let { success, data, error } = await trackingIdsApi.getTrackingIds({ page: 1, size: 10000 }).catch(e => ({ success: false, error: e.message }))
            if (success) {
                primaryTrackingIdOptions.value = data.data.map(item => {
                  if(item.subTrackingIds.length>0){
                    item.subTrackingIds.forEach(subItem=>{
                      subTrackingIdOptions.value.push({
                        name:subItem.trackingId,
                        id:String(subItem.id),
                        parentId:String(item.id)
                      })
                      
                    })
                  }
                    return {
                        name: item.trackingId,
                        id: String(item.id)
                    }
                })
                allSubTrackingIdOptions.value=JSON.parse(JSON.stringify(subTrackingIdOptions.value)) 
            }
            else{
              message.error(error)

            }
}
getBrandsList('')
getTrackingId()

publisherProductApi.getSourceOptionsByPublisher().then((res) => {
  sourceOptions.value = res.data
})

function selectbrand(name) {
  brandSelected.value = true
  filters.value.brandName = name

  if (!options.includes('brandName')) {
    filtersNum.value++
    options.push('brandName')
  }
}

defineExpose({
  reset
})
</script>

<style lang="less" scoped>
@import '../../../assets/less/filter-popup.less';
@import '../../../assets/less/country-select.less';

.filters {
  position: relative;
}

.filters-down:deep(.ant-input-number-handler-wrap) {
  opacity: 1 !important;
}
</style>